export default __webpack_public_path__ + "static/media/event-team-3.a06d9282.jpg";